module.exports = __webpack_public_path__ + "img/csr_110923_B.6fb4b5e5.jpg";